import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_PSF_TO_SAP_LOCAL_FLOW = createFcmDetails('starfish_psf_to_sap_local_flow', {
	owner: 'starfish',
	context: 'Supporter to Starter Local Flow in PSF',
	import: false,
	description:
		'Configuration flag that allows Product to configure the prompts to generate petition titles for the Supporter to Starter Local Flow in PSF. isEnabled determines whether the flow is enabled for users. If yes, then systemPrompt specifies the output format that ChatGPT should return and prompt is an array that will determine what will be sent to the OpenAI API call. Each object in the array contains a "replacer" which is the petition variable we will replace in the "text" field.',
	template: {
		isEnabled: true,
		systemPrompt: `
    You work for Change.org. Many petitions published on Change.org have a national or global scope.
    Your role is to find potential ways for these global/national causes to be applied at the local level (either state or city).
    You do that by recommending 3 potential local petition titles to users who signed a given global/national petition.
    Petition titles should be 90 characters maximum.
    Your response is ONLY a single JSON file with these 3 options, matching the following structure:

    \`\`\`json
    {
      optionA: 'Petition title option A',
      optionB: 'Petition title option B',
      optionC: 'Petition title option C'
    }
    \`\`\`

    Whether you have access to a user's city, state, or country, you can always offer petition title recommendations at the city or state level.
    If you don't have the City or State information, just stay vague by saying 'in my city' or 'in my state'.`,
		prompt: [
			{
				replacer: 'location',
				text: 'The user is based in %{location}.',
			},
			{
				replacer: 'ask',
				text: 'This is the petition title: %{ask}.',
			},
			{
				replacer: 'description',
				text: 'Here is the petition content: %{description}.',
			},
		],
	},
});
